<template>
  <div>
    <a class="btn btn-warning" ref="open" @click="openmodal" target="_blank">
      软件二维码
      <i class="fa fa-qrcode"></i>
    </a>
     <div class="modal" ref="mymodal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn btn-danger pull-right" data-dismiss="modal">
              <span>&times;</span>
            </button>
            <h4>请扫描二维码</h4>
          </div>
          <div class="modal-body">
            <img class="img-responsive center-block" src="../common/images/BU01download.jpg" />>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    openmodal() {
      $(this.$refs.mymodal).modal("show");
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/base/qrdownload.vue